import React from 'react';
import Shimmer from '../../../core/Shimmer/Shimmer';
import ShimmerWrapper from '../../../core/Shimmer/ShimmerWrapper';

const CompanyFormSkeleton = ({}) => {
    return (
        <ShimmerWrapper spacing={32}>
            <ShimmerWrapper direction='row' spacing={24} align='center'>
                <ShimmerWrapper direction='row' spacing={8} align='center'>
                    <Shimmer circle size={18} />
                    <Shimmer width='140px' height={16} />
                </ShimmerWrapper>

                <ShimmerWrapper direction='row' spacing={8} align='center'>
                    <Shimmer circle size={18} />
                    <Shimmer width='140px' height={16} />
                </ShimmerWrapper>

                <ShimmerWrapper direction='row' spacing={8} align='center'>
                    <Shimmer circle size={18} />
                    <Shimmer width='140px' height={16} />
                </ShimmerWrapper>
            </ShimmerWrapper>

            <ShimmerWrapper
                display='grid'
                spacing={24}
                style={{ gridTemplateColumns: '1fr 1fr 1fr' }}
            >
                <ShimmerWrapper spacing={8}>
                    <Shimmer width='120px' height={16} />
                    <Shimmer height={40} radius={8} />
                </ShimmerWrapper>

                <ShimmerWrapper spacing={8}>
                    <Shimmer width='160px' height={16} />
                    <Shimmer height={40} radius={8} />
                </ShimmerWrapper>

                <ShimmerWrapper spacing={8}>
                    <Shimmer width='150px' height={16} />
                    <Shimmer height={40} radius={8} />
                </ShimmerWrapper>

                <ShimmerWrapper spacing={8}>
                    <Shimmer width='160px' height={16} />
                    <Shimmer height={40} radius={8} />
                    <Shimmer width='90%' height={14} />
                </ShimmerWrapper>

                <ShimmerWrapper spacing={8}>
                    <Shimmer width='160px' height={16} />
                    <Shimmer height={40} radius={8} />
                </ShimmerWrapper>

                <ShimmerWrapper spacing={8}>
                    <Shimmer width='160px' height={16} />
                    <Shimmer height={40} radius={8} />
                    <Shimmer width='90%' height={14} />
                </ShimmerWrapper>
            </ShimmerWrapper>
        </ShimmerWrapper>
    );
};

export default CompanyFormSkeleton;
